import Illustration_01_prev from '../images/illustrations/Illustration-01_preview.webp';
import Illustration_01_orig from '../images/illustrations/Illustration-01_original.webp';
import Illustration_02_prev from '../images/illustrations/Illustration-02_preview.webp';
import Illustration_02_orig from '../images/illustrations/Illustration-02_original.webp';
import Illustration_03_prev from '../images/illustrations/Illustration-03_preview.webp';
import Illustration_03_orig from '../images/illustrations/Illustration-03_original.webp';
import Illustration_04_prev from '../images/illustrations/Illustration-04_preview.webp';
import Illustration_04_orig from '../images/illustrations/Illustration-04_original.webp';
import Illustration_05_prev from '../images/illustrations/Illustration-05_preview.webp';
import Illustration_05_orig from '../images/illustrations/Illustration-05_original.webp';
import Illustration_06_prev from '../images/illustrations/Illustration-06_preview.webp';
import Illustration_06_orig from '../images/illustrations/Illustration-06_original.webp';
import Illustration_07_prev from '../images/illustrations/Illustration-07_preview.webp';
import Illustration_07_orig from '../images/illustrations/Illustration-07_original.webp';
import Illustration_08_prev from '../images/illustrations/Illustration-08_preview.webp';
import Illustration_08_orig from '../images/illustrations/Illustration-08_original.webp';
import Illustration_09_prev from '../images/illustrations/Illustration-09_preview.webp';
import Illustration_09_orig from '../images/illustrations/Illustration-09_original.webp';
import Illustration_10_prev from '../images/illustrations/Illustration-10_preview.webp';
import Illustration_10_orig from '../images/illustrations/Illustration-10_original.webp';
import Illustration_11_prev from '../images/illustrations/Illustration-11_preview.webp';
import Illustration_11_orig from '../images/illustrations/Illustration-11_original.webp';
import Illustration_12_prev from '../images/illustrations/Illustration-12_preview.webp';
import Illustration_12_orig from '../images/illustrations/Illustration-12_original.webp';
import Illustration_13_prev from '../images/illustrations/Illustration-13_preview.webp';
import Illustration_13_orig from '../images/illustrations/Illustration-13_original.webp';
import Illustration_14_prev from '../images/illustrations/Illustration-14_preview.webp';
import Illustration_14_orig from '../images/illustrations/Illustration-14_original.webp';
import Illustration_15_prev from '../images/illustrations/Illustration-15_preview.webp';
import Illustration_15_orig from '../images/illustrations/Illustration-15_original.webp';
import Illustration_16_prev from '../images/illustrations/Illustration-16_preview.webp';
import Illustration_16_orig from '../images/illustrations/Illustration-16_original.webp';
import Illustration_17_prev from '../images/illustrations/Illustration-17_preview.webp';
import Illustration_17_orig from '../images/illustrations/Illustration-17_original.webp';
import Illustration_18_prev from '../images/illustrations/Illustration-18_preview.webp';
import Illustration_18_orig from '../images/illustrations/Illustration-18_original.webp';
import Illustration_19_prev from '../images/illustrations/Illustration-19_preview.webp';
import Illustration_19_orig from '../images/illustrations/Illustration-19_original.webp';
import Illustration_20_prev from '../images/illustrations/Illustration-20_preview.webp';
import Illustration_20_orig from '../images/illustrations/Illustration-20_original.webp';
import Illustration_21_prev from '../images/illustrations/Illustration-21_preview.webp';
import Illustration_21_orig from '../images/illustrations/Illustration-21_original.webp';
import Illustration_22_prev from '../images/illustrations/Illustration-22_preview.webp';
import Illustration_22_orig from '../images/illustrations/Illustration-22_original.webp';
import Illustration_23_prev from '../images/illustrations/Illustration-23_preview.webp';
import Illustration_23_orig from '../images/illustrations/Illustration-23_original.webp';
import Illustration_24_prev from '../images/illustrations/Illustration-24_preview.webp';
import Illustration_24_orig from '../images/illustrations/Illustration-24_original.webp';
import Illustration_25_prev from '../images/illustrations/Illustration-25_preview@1x.webp';
import Illustration_25_orig from '../images/illustrations/Illustration-25_original@1x.webp';
import Illustration_26_prev from '../images/illustrations/Illustration-26_preview@1x.webp';
import Illustration_26_orig from '../images/illustrations/Illustration-26_original@1x.webp';
import Illustration_27_prev from '../images/illustrations/Illustration-27_preview@1x.webp';
import Illustration_27_orig from '../images/illustrations/Illustration-27_original@1x.webp';
import Illustration_28_prev from '../images/illustrations/Illustration-28_preview@1x.webp';
import Illustration_28_orig from '../images/illustrations/Illustration-28_original@1x.webp';
import Illustration_29_prev from '../images/illustrations/Illustration-29_preview@1x.webp';
import Illustration_29_orig from '../images/illustrations/Illustration-29_original@1x.webp';
import Illustration_30_prev from '../images/illustrations/Illustration-30_preview@1x.webp';
import Illustration_30_orig from '../images/illustrations/Illustration-30_original@1x.webp';
import Illustration_31_prev from '../images/illustrations/Illustration-31_preview@1x.webp';
import Illustration_31_orig from '../images/illustrations/Illustration-31_original@1x.webp';
import Illustration_32_prev from '../images/illustrations/Illustration-32_preview@1x.webp';
import Illustration_32_orig from '../images/illustrations/Illustration-32_original@1x.webp';
import Illustration_33_prev from '../images/illustrations/Illustration-33_preview@1x.webp';
import Illustration_33_orig from '../images/illustrations/Illustration-33_original@1x.webp';
import Illustration_34_prev from '../images/illustrations/Illustration-34_preview@1x.webp';
import Illustration_34_orig from '../images/illustrations/Illustration-34_original@1x.webp';
import Illustration_35_prev from '../images/illustrations/Illustration-35_preview@1x.webp';
import Illustration_35_orig from '../images/illustrations/Illustration-35_original@1x.webp';
import Illustration_36_prev from '../images/illustrations/Illustration-36_preview@1x.webp';
import Illustration_36_orig from '../images/illustrations/Illustration-36_original@1x.webp';

export const illustrationsGalleryItems = [
  {
    preview: Illustration_01_prev,
    original: Illustration_01_orig,
    description:
      "Illustration for the Wimmelbook ''Transport'', PET publishing house",
  },
  {
    preview: Illustration_02_prev,
    original: Illustration_02_orig,
    description:
      'Illustration for the annual calendar for the Raduga advertising agency',
  },
  {
    preview: Illustration_03_prev,
    original: Illustration_03_orig,
    description:
      "Illustration for the author of the book ''The Boy from Mars''",
  },
  {
    preview: Illustration_04_prev,
    original: Illustration_04_orig,
    description:
      "Illustration for the Wimmelbook ''Kindergarten'',PET publishing house",
  },
  {
    preview: Illustration_05_prev,
    original: Illustration_05_orig,
    description: "Illustration for the author of the book ''Go to Bed, Ollie''",
  },
  {
    preview: Illustration_06_prev,
    original: Illustration_06_orig,
    description: 'Illustration of a board game for a travel company',
  },
  {
    preview: Illustration_07_prev,
    original: Illustration_07_orig,
    description: 'Character development',
  },
  {
    preview: Illustration_08_prev,
    original: Illustration_08_orig,
    description: "Illustration for the book ''The Boy from Mars''",
  },
  {
    preview: Illustration_09_prev,
    original: Illustration_09_orig,
    description: 'Christmas card to order',
  },
  {
    preview: Illustration_10_prev,
    original: Illustration_10_orig,
    description: 'Custom illustration for the book',
  },
  {
    preview: Illustration_11_prev,
    original: Illustration_11_orig,
    description: 'Illustrations for the book about Rapunzel',
  },
  {
    preview: Illustration_12_prev,
    original: Illustration_12_orig,
    description:
      'Illustrations for the book about Crocodile, for the author from Belgium',
  },
  {
    preview: Illustration_13_prev,
    original: Illustration_13_orig,
    description: 'Christmas illustration to order',
  },
  {
    preview: Illustration_14_prev,
    original: Illustration_14_orig,
    description: 'Illustration and cover design for a British publisher',
  },
  {
    preview: Illustration_15_prev,
    original: Illustration_15_orig,
    description:
      'Complete illustration of books (2 parts) about a crocodile for a writer from Belgium',
  },
  {
    preview: Illustration_16_prev,
    original: Illustration_16_orig,
    description:
      'Complete illustration of books (2 parts) about a crocodile for a writer from Belgium',
  },
  {
    preview: Illustration_17_prev,
    original: Illustration_17_orig,
    description: 'A full illustrated pug and corgi book for a US author',
  },
  {
    preview: Illustration_18_prev,
    original: Illustration_18_orig,
    description: 'A full illustrated book',
  },
  {
    preview: Illustration_19_prev,
    original: Illustration_19_orig,
    description: 'Beth the Witch Creates a Pet',
  },
  {
    preview: Illustration_20_prev,
    original: Illustration_20_orig,
    description: "Illustration to book ''The Dragon and The Grandma''",
  },
  {
    preview: Illustration_21_prev,
    original: Illustration_21_orig,
    description: 'The Boy from Mars',
  },
  {
    preview: Illustration_22_prev,
    original: Illustration_22_orig,
    description: 'Good Night Everybody!',
  },
  {
    preview: Illustration_23_prev,
    original: Illustration_23_orig,
    description:
      "Illustration to book 'Jednorožec, který snil o sněhu', Pierot Vydavateľstvo",
  },
  {
    preview: Illustration_24_prev,
    original: Illustration_24_orig,
    description:
      "Illustration to book 'Jednorožec, který snil o sněhu', Pierot Vydavateľstvo",
  },
  {
    preview: Illustration_25_prev,
    original: Illustration_25_orig,
    description:
      "Illustration to book 'Bunny and Hedgehog on the planet Englishi'",
  },
  {
    preview: Illustration_26_prev,
    original: Illustration_26_orig,
    description:
      "Illustration to book 'Bunny and Hedgehog on the planet Englishi'",
  },
  {
    preview: Illustration_27_prev,
    original: Illustration_27_orig,
    description:
      "Illustrations to book '(Not) a terrible story about a monster tablet'",
  },
  {
    preview: Illustration_28_prev,
    original: Illustration_28_orig,
    description:
      "Illustrations to book '(Not) a terrible story about a monster tablet'",
  },
  {
    preview: Illustration_29_prev,
    original: Illustration_29_orig,
    description: 'Illustration Cat and Turtle',
  },
  {
    preview: Illustration_30_prev,
    original: Illustration_30_orig,
    description: "Illustration to book 'We love our glasses'",
  },
  {
    preview: Illustration_31_prev,
    original: Illustration_31_orig,
    description: "Illustration to children's book 'The house spirit in the Chok-Chok Network', Old Lion Publishing House",
  },
  {
    preview: Illustration_32_prev,
    original: Illustration_32_orig,
    description: "Illustration to children's book 'The house spirit in the Chok-Chok Network', Old Lion Publishing House",
  },
  {
    preview: Illustration_33_prev,
    original: Illustration_33_orig,
    description: "Illustration to children's book 'Planet Englishi', Mandrivets Publishing House",
  },
  {
    preview: Illustration_34_prev,
    original: Illustration_34_orig,
    description: "Illustration to children's book 'Planet Englishi', Mandrivets Publishing House",
  },
  {
    preview: Illustration_35_prev,
    original: Illustration_35_orig,
    description: "Illustration to children's book 'Hotel in the Castle on the Edge', Old Lion Publishing House",
  },
  {
    preview: Illustration_36_prev,
    original: Illustration_36_orig,
    description: "Illustration to children's book 'Hotel in the Castle on the Edge', Old Lion Publishing House",
  },
];
